import type { GetAddressCityListApiResponse } from '@navio/nsdk';
import { keepPreviousData } from '@tanstack/react-query';
import { URLKeys } from 'noddi-async';
import { FilterOptionSource } from 'noddi-ui-web';
import { useDebounceValue } from 'noddi-util';
import { useState } from 'react';
import { toFilterOptionSource, useFilterOptionsGet } from '../useFilterOptionsGet';

/** Title, description and visible options of this filter, for the builder next to its options. */
export const CITY_FILTER_TEXT = {
  title: 'Cities',
  description: 'Filter by the city of the booking address.',
  defaultVisibleOptions: 3
};

/** Booking address cities as filter options, searchable. For `unit.multiSelect`. */
export const useCityOptions = (): FilterOptionSource<string> => {
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounceValue({ value: search, delay: 300 });

  const query = useFilterOptionsGet({
    type: URLKeys.getBookingAddressCities,
    input: { search: debouncedSearch },
    queryConfig: { select: toCityOptions, placeholderData: keepPreviousData }
  });

  return toFilterOptionSource(query, 'string', { search, onSearch: setSearch });
};

const toCityOptions = ({ results }: GetAddressCityListApiResponse) =>
  results.map((city) => ({ value: city, label: city }));
